<app-header></app-header>
<app-sidebar></app-sidebar>
<app-right-sidebar></app-right-sidebar>
<div [dir]="direction" style="background-color: white;height: 100vh;">
  <router-outlet></router-outlet>
</div>
